<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13HpgUt/tc-custom/9781783830893.jpg?1721404830050" alt="This image is the cover for the book Wellington's Highland Warriors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wellington's Highland Warriors
      </h1>
      <p class="bookDescription body article font2">
        <p>'Wellingtons Highland Warriors' covers the early history of the British Armys Highland regiments, from the raising of the Black Watch in 1739 to the battle of Waterloo in 1815. Stuart Reid provides an entertaining and thoroughly original study of the circumstances in which the regiments were authorized and recruited, not just in the Highlands but all across Scotland, so that Highlanders and Scotchmen became synonymous.  It also tells the story of how they acquitted themselves in almost every corner of the globe from the bogs of Ireland to the burning plains of India, and in the process earning for themselves a reputation which is literally second to none.Each chapter follows a theme based around the experiences of one particular regiment and employs extensive but careful use of contemporary correspondence and memoirs to let those involved tell the story in their own words.  The story is a fascinating one which reveals the very different expectations and experiences of Highland soldiers; filled with engaging rogues such as Simon Fraser and Allan Cameron of Erracht, with stories of bitter feuds as rival chieftains and Highland proprietors battled each other for recruits, and those recruits themselves who were more than capable of giving as good as they got; demanding and receiving legally binding concessions from their landlords turned recruiters and then like George Gordon from the Cabrach, striding forth in high dress with his sword by his side to announce his new profession in a calculated display of swank quite incomprehensible to his English counterparts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stuart Reid, Philip Haythornthwaite
      </h2>
      
      <p class="authorDescription body article">Stuart Reid is a prolific and well-known writer on a wide range of military subjects, and he is an expert on the military history of Scotland. His pioneering study Like Hungry Wolves remains unchallenged as the best narrative account of Culloden. His other books include: The Campaigns of Montrose, All the King's Armies: A Military History of The English Civil War, Wolfe: The Life and Career of General James Wolfe, Wellington's Highland Warriors: From the Black Watch Mutiny to the Battle of Waterloo and The Battle of Plassey 1757: The Victory That Won an Empire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d1024b0